import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export const FacebookPixel = () => {
  useEffect(() => {
    // Only add the script if it hasn't been added already
    if (!window.fbq) {
      // Initialize Facebook Pixel
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // Fix for the parentNode error - check if s exists first
        if (s) {
          s.parentNode.insertBefore(t, s);
        } else {
          // Fallback if no script tag exists yet - append to head
          b.getElementsByTagName('head')[0].appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // Initialize with your Pixel ID
      window.fbq('init', '1910681403023710');
      // Track PageView
      window.fbq('track', 'PageView');
    }
    // Clean up function
    return () => {
      // No cleanup needed for the script
    };
  }, []);
  return <>
      {/* Add noscript pixel image for browsers with JavaScript disabled */}
      <noscript data-id="element-121">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1910681403023710&ev=PageView&noscript=1" alt="" data-id="element-122" />
      </noscript>
    </>;
};
// Helper functions to make tracking events easier
export const trackPixelEvent = (event: string, params?: object) => {
  if (window.fbq) {
    window.fbq('track', event, params);
  }
};
export const trackPixelCustomEvent = (event: string, params?: object) => {
  if (window.fbq) {
    window.fbq('trackCustom', event, params);
  }
};
export default FacebookPixel;